var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1443 27C15.8142 27 15.4785 26.9411 15.1372 26.8232C14.7959 26.7053 14.495 26.5167 14.2348 26.2574L11.7949 24.0297C9.29609 21.743 7.03866 19.4743 5.02263 17.2235C3.0066 14.9727 1.99906 12.4913 2 9.77935C2 7.56341 2.74258 5.71287 4.22772 4.22772C5.71287 2.74257 7.56341 2 9.77935 2C11.0288 2 12.2074 2.26497 13.3154 2.79491C14.4234 3.32485 15.3663 4.04998 16.1443 4.9703C16.9222 4.05092 17.8652 3.32626 18.9731 2.79632C20.0811 2.26638 21.2598 2.00094 22.5092 2C24.7251 2 26.5757 2.74257 28.0608 4.22772C29.546 5.71287 30.2885 7.56341 30.2885 9.77935C30.2885 12.4903 29.2867 14.9774 27.2829 17.2405C25.2791 19.5035 23.0042 21.7784 20.4583 24.0651L18.0537 26.2574C17.7944 26.5167 17.4941 26.7053 17.1528 26.8232C16.8114 26.9411 16.4752 27 16.1443 27Z",
    fill: "#ED0000",
    stroke: "white",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart-filled.1b04a74800afcd43c6ff7c4f8e7a04f6.svg";
export { ForwardRef as ReactComponent };